<template>
    <div class="tab-menu">
        <Scroll class="wrapper" ref="scroll"
                :probe-type="3"
                :pull-up-load="true">
            <div class="menu-list">
                <div class="menu-list-item"
                     :class="{active: index===currentIndex}"
                    v-for="(item,index) in categories"
                     :key="index"
                     @click="itemClick(index)">
                    {{item.title}}
                </div>
            </div>

        </scroll>

    </div>
</template>

<script>
    import Scroll from "../../../components/common/scroll/Scroll";
    export default {
        name: "TabMenu",
        props:{
          categories:Array,
        },
        components:{
            Scroll,
        },
        data() {
            return {
                currentIndex: 0
            }
        },
        mounted() {
            setTimeout(()=>{
                this.$refs.scroll.scroll.refresh();
            },1000)
            this.$refs.scroll.scroll.refresh();
        },
        activated(){
            // this.$refs.scroll.scroll.refresh();
        },
        methods: {
            itemClick(index) {
                this.currentIndex = index
                this.$emit('selectItem', index)
            }
        }
    }
</script>

<style scoped>
    .tab-menu {
        background-color: #f6f6f6;
        height: 100%;
        width: 100px;
        box-sizing: border-box;
    }
    .menu-list-item {
        height: 45px;
        line-height: 45px;
        text-align: center;
        font-size: 14px;
    }
    .menu-list-item.active {
        font-weight: 700;
        color: var(--color-high-text);
        background-color: #fff;
        border-left: 3px solid var(--color-high-text);
    }
    .wrapper{
        position: relative;
        height: calc(100%);
        /*height: 580px;*/
        /*background-color: red;*/
        overflow: hidden;
        /*overflow: hidden;*/
    }
</style>